import 'whatwg-fetch';
import { windowOnLoad } from './common';

/* eslint-disable */
const req = require.context('../css/about', true, /^(.*\.(css$))[^.]*$/igm);
req.keys().forEach((key)=>{req(key);});
/* eslint-enable */

/**
 * sprout member API
 * Append each member block
 */
fetch('https://lab.25sprout.com/avatar/apo/25sproutMemberList.php')
	.then((response) => response.json())
	.then(({ staffs }) => {
		Object.keys(staffs).forEach((key) => {
			document.querySelector('.member-wrapper').appendChild(
				document.querySelector('.member-block:first-child').cloneNode(true),
			);

			const memberBlock = document.querySelector('.member-block:last-child');
			memberBlock.children[0].setAttribute('src', staffs[key].pic.large);
			memberBlock.children[1].innerText = staffs[key].name;
			memberBlock.children[2].innerText = staffs[key].title.join(' / ');
		});
	});

window.onload = () => {
	windowOnLoad();

	const bodyHeight = document.body.offsetHeight;
	const quoteHeight = window.innerHeight + (document.querySelector('.quote-block').offsetHeight / 2);
	let itemAnimated = false;

	window.addEventListener('scroll', (e) => {
		const ratio = e.currentTarget.pageYOffset / bodyHeight;

		/**
		 * parallax
		 */
		document.querySelector('.content-section.-about').setAttribute(
			'style',
			`background-position: ${100 * (1 - ratio)}% 50%`,
		);

		document.querySelector('.content-section.-about > .company-name').setAttribute(
			'style',
			`left: -${Math.floor(1300 * ratio)}px`,
		);

		/**
		 * four quote fade in from left and right
		 */
		if (itemAnimated === false && e.currentTarget.pageYOffset >= quoteHeight) {
			itemAnimated = true;

			document.querySelectorAll('.way-item.-first')[0].className += ' fadeInLeft';
			document.querySelectorAll('.way-item.-first')[1].className += ' fadeInRight';

			setTimeout(() => {
				document.querySelectorAll('.way-item.-second')[0].className += ' fadeInLeft';
				document.querySelectorAll('.way-item.-second')[1].className += ' fadeInRight';
			}, 500);
		}
	});
};



// WEBPACK FOOTER //
// ./src/js/about.js